import { database } from "../firebase";
import { ref, runTransaction } from "firebase/database";
import { getAuth, signOut } from "firebase/auth";

/**
 * Atomically increments the requestToUpload counter for a scan.
 */
export async function incrementUploadRequest(userPath, scanKey) {
  const requestRef = ref(database, `data/scans/${userPath}/${scanKey}/requestToUpload`);
  await runTransaction(requestRef, (v) =>
    Number.isNaN(Number(v)) ? 1 : Number(v) + 1
  );
}

/**
 * Updates the status and note for a scan using a transaction.
 */
export async function updateScanStatus(userPath, scanKey, targetStatus, note) {
  const scanRef = ref(database, `data/scans/${userPath}/${scanKey}`);
  await runTransaction(scanRef, (currentData) => {
    if (currentData) {
      currentData.status = targetStatus;
      currentData.note = note.trim();
    }
    return currentData;
  });
}

/**
 * Signs out the current user and reloads the page.
 */
export async function signOutUser() {
  await signOut(getAuth());
  window.location.reload();
}
